import { render, staticRenderFns } from "./WordDialog.vue?vue&type=template&id=af5ea73e&scoped=true&"
import script from "./WordDialog.vue?vue&type=script&lang=js&"
export * from "./WordDialog.vue?vue&type=script&lang=js&"
import style0 from "./WordDialog.vue?vue&type=style&index=0&id=af5ea73e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5ea73e",
  null
  
)

export default component.exports